import { LocalizedEnum, LocalizedText, useFeatureFlag } from '@mews/framework';
import { FeatureFlag, TextKey } from '@mews-commander/enums';
import { TooltippedIcon } from '@mews-commander/ui';
import { IconName } from '@optimus-web/icons';
import { Stack } from '@optimus-web/core';
import { isSepaPaymentMethod } from './utils';
import { PaymentMethodRecord } from './types';

type Props = Pick<PaymentMethodRecord, 'paymentMethod' | 'wallet' | 'format' | 'paymentPlanId'>;

const PaymentMethodTypeLabel = ({ paymentMethod, wallet, format }: Omit<Props, 'paymentPlanId'>) => {
    if (isSepaPaymentMethod(paymentMethod)) {
        return <LocalizedText textKey={TextKey.PaymentMethodDirectDebit} />;
    }
    if (wallet) {
        return <LocalizedEnum prefix="PaymentCardWallet" value={wallet} />;
    }
    return format ? <LocalizedEnum prefix="PaymentCardFormat" value={format} /> : null;
};

const PaymentPlanIcon = ({ paymentPlanId }: Pick<Props, 'paymentPlanId'>) => {
    const isPaymentPlanEnabled = useFeatureFlag(FeatureFlag.paymentPlanEnabled);

    if (!isPaymentPlanEnabled || !paymentPlanId) {
        return null;
    }

    return (
        <TooltippedIcon
            size="small"
            value={IconName.CustomLink}
            tooltip={TextKey.PaymentMethodTypeLinkedPaymentPlanTooltip}
        />
    );
};

export const PaymentMethodType = ({ paymentMethod, wallet, format, paymentPlanId }: Props) => (
    <Stack itemAlignment="center" spacing="100">
        <PaymentMethodTypeLabel paymentMethod={paymentMethod} wallet={wallet} format={format} />
        <PaymentPlanIcon paymentPlanId={paymentPlanId} />
    </Stack>
);
